<template>
	<view class="box">
		<view class="box_head">
			<image src="@/static/logo@2x.png" mode="widthFix"></image>
			<text class="box_head_a" v-if="info.status === 0">访客预约待审核</text>
			<text class="box_head_a" style="color: ;" v-if="info.status === 2">访客预约审核通过</text>
			<text class="box_head_a" v-if="info.status === 3">访客预约审核不通过</text>
			<text class="box_head_b" v-if="info.status === 0">您的预约单已提交审核，请等待被访人审核</text>
			<text class="box_head_b" v-if="info.status === 2">您的来访申请已审核通过，请在门卫处进行登</text>
			<text class="box_head_b" v-if="info.status === 3">您的来访申请已被驳回，原因是：这是原因</text>
		</view>
		<view class="box_list">
			<view class="box_list_label">拜访信息</view>
			<view class="box_list_item">
				<view class="box_list_item_label">拜访员工：</view>
				<view class="box_list_item_val">{{info.visitUserName}}</view>
			</view>
			<view class="box_list_item">
				<view class="box_list_item_label">车牌号：</view>
				<view class="box_list_item_val">{{info.carNos}}</view>
			</view>
			<view class="box_list_item">
				<view class="box_list_item_label">拜访事由：</view>
				<view class="box_list_item_val">{{info.visitReason}}</view>
			</view>
			<view class="box_list_item">
				<view class="box_list_item_label">拜访时间：</view>
				<view class="box_list_item_val">{{info.visitTime}}</view>
			</view>
			<view class="box_list_item">
				<view class="box_list_item_label">访问门禁：</view>
				<view class="box_list_item_val" v-if="info.doorGroupName && info.doorGroupName.length > 0">{{info.doorGroupName.join('、')}}</view>
			</view>
			<view class="box_list_item" v-for="(item, index) in info.withVisitsList" :key="index">
				<view class="box_list_item_label">随访人员{{index + 1}}：</view>
				<view class="box_list_item_val">{{item.name}} {{item.phone}}</view>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				info: {}
			};
		},
		onLoad(option) {
			this.$u.api.detail({ id: option.id })
				.then(res => {
					if (res.code === 200) {
						console.log(res)
						this.info = res.data
					}
				})
		}
	}
</script>
<style>
	page {
		background-color: #f7f7f7;
	}
</style>
<style lang="scss" scoped>
	.box {
		width: 100%;
		.box_head {
			width: 100%;
			padding: 40rpx 0;
			box-sizing: border-box;
			background-color: #ffffff;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			image {
				width: 320rpx;
				height: 320rpx;
			}
			.box_head_a {
				font-size: 36rpx;
				font-weight: 600;
				color: #025EEF;
				margin-top: 30rpx;
			}
			.box_head_b {
				font-size: 26rpx;
				font-weight: 400;
				color: #666666;
				margin-top: 24rpx;
			}
		}
		.box_list {
			width: 100%;
			margin-top: 20rpx;
			background-color: #ffffff;
			padding: 40rpx 30rpx;
			box-sizing: border-box;
			.box_list_label {
				font-size: 32rpx;
				font-weight: 500;
				color: #222222;
			}
			.box_list_item {
				width: 100%;
				display: flex;
				align-items: center;
				margin-top: 30rpx;
				.box_list_item_label {
					font-size: 28rpx;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					color: #666666;
				}
				.box_list_item_val {
					font-size: 28rpx;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					color: #333333;
				}
			}
		}
	}
</style>
